import React from 'react';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// Function to determine the slider marks based on the selected state
const getSliderMarks = (selectedState) => {
  if (selectedState === 'VI' || selectedState === 'PR') {
    return [
      { value: 0, label: '0%' },
      { value: 100, label: '100%' },
    ];
  }
  return [
    { value: 0, label: '0%' },
    { value: 50, label: '50%' },
  ];
};

export default function UnusedSlider({ onUnusedChange, unusedValue, selectedState }) {
  const marks = getSliderMarks(selectedState);
  const isDisabled = selectedState === 'VI' || selectedState === 'PR';

  return (
      <Box sx={{ width: 340 }}>
        <Typography id="non-linear-slider" gutterBottom sx={{ fontSize: '14px' }}>
          For CAIs & Deployment & Non-Deployment Efforts: <span style={{ fontWeight: 'bold' }}> {`${unusedValue}%`}</span>
        </Typography>
        <Slider
            aria-labelledby="non-linear-slider"
            value={unusedValue}
            min={0}
            step={1}
            max={selectedState === 'VI' || selectedState === 'PR' ? 100 : 50}
            marks={marks}
            onChange={onUnusedChange}
            valueLabelDisplay="auto"
            disabled={isDisabled}
        />
      </Box>
  );
}
